import { Link } from "react-router-dom";

export function Brand({ dark = false, subtitle = "Support Desk" }) {
  return (
    <Link to="/" className="flex items-center gap-3" data-testid="brand-link">
      <span className="grid h-11 min-w-[44px] place-items-center rounded-xl border-2 border-black bg-black px-1.5 brut-shadow-sm">
        <img src="/logo.png" alt="Virality School" className="h-10 w-auto object-contain" data-testid="brand-logo" />
      </span>
      <span className="leading-tight">
        <span className={`block font-display text-lg font-extrabold ${dark ? "text-white" : "text-black"}`}>Virality School</span>
        <span className={`block text-xs font-bold uppercase tracking-[0.2em] ${dark ? "text-[#FACC15]" : "text-zinc-600"}`}>{subtitle}</span>
      </span>
    </Link>
  );
}

export function PendingBadge({ label = "Pending integration", testId }) {
  return (
    <span
      data-testid={testId}
      className="inline-flex items-center gap-1.5 rounded-full border border-dashed border-zinc-500 bg-zinc-50 px-2.5 py-1 text-[11px] font-bold uppercase tracking-wider text-zinc-600"
    >
      <span className="h-1.5 w-1.5 rounded-full bg-zinc-400" />
      {label}
    </span>
  );
}
